import { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Card } from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { referrerModel } from 'entities/referrer';
import { useAppDispatch, useLoadingState, useShallowSelector } from 'shared';
import { Address } from 'viem';

import { QUERY_LIMIT } from '../../constants';

import { ReferralItemLoader, ReferralListEmpty } from './components';
import { ReferralItemsList, ReferralList } from './referral-list';

const ReferralItemsLoaders = () => Array.from({ length: QUERY_LIMIT }, (_, i) => <ReferralItemLoader key={i} />);

export const ReferralListView = () => {
  const { state } = useWagmiAuth();
  const dispatch = useAppDispatch();
  const [loadMoreRef, inView] = useInView();

  const { data, hasNext } = useShallowSelector(referrerModel.selectUserReferrals);
  const [isLoading] = useLoadingState([referrerModel.actionTypes.GET_USER_REFERRALS]);

  const loadNextPage = useCallback(() => {
    if (hasNext && !isLoading) {
      dispatch(
        referrerModel.thunks.getUserReferrals({
          page: data.length,
          address: state.address as Address,
          limit: QUERY_LIMIT,
        }),
      );
    }
  }, [data.length, dispatch, hasNext, isLoading, state.address]);

  useEffect(() => {
    if (inView) {
      loadNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  useEffect(() => {
    loadNextPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data.length && !isLoading) {
    return <ReferralListEmpty />;
  }

  return (
    <Card
      sx={(theme) => ({
        flex: 1,
        padding: theme.spacing(3, 2),
      })}
    >
      <ReferralList>
        <ReferralItemsList data={data} loadMoreRef={loadMoreRef} />
        {isLoading && <ReferralItemsLoaders />}
      </ReferralList>
    </Card>
  );
};
